/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/HomeOutlined';

export function BreadCrumbs({ items }) {
  if (!items || !items.length) {
    return "";
  }

  return (
    <ul className="breadcrumb breadcrumb-transparent  p-0 my-2">
      <li className="breadcrumb-item">
        <Link to="/dashboard">
          <HomeIcon className="text-muted" />
        </Link>
      </li>
      {items.map((item, index) => (
        <li key={`bc${index}`} className="breadcrumb-item">
          <a className="text-muted" href={item.pathname}>
            {item.title}
          </a>
        </li>
      ))}
    </ul>
  );
}
